import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Card, Row, Col, Typography } from "antd";
import Layout from "../../ReusableComponents/Layout";
import getService from "../../Redux/APIs/ServiceAPIs/get";
import { Icons } from "../../Utils/icons-utils";

const { Text } = Typography;

const Services = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [services, setServices] = useState([]);

  useEffect(() => {
    dispatch(getService(setServices));
  }, []);

  const onServiceClick = (service) => {
    localStorage.setItem("service", JSON.stringify(service));
    localStorage.removeItem("popUp");
    localStorage.setItem("popUp", false);
    navigate(`/service/${service.name}`);
  };

  return (
    <Layout>
      <Row gutter={[16, 16]}>
        {services &&
          services.map((service, id) => (
            <Col key={id} xs={12} sm={8} md={6} lg={4} xl={3}>
              <Card
                hoverable
                onClick={() => onServiceClick(service)}
                style={{ textAlign: "center", height: "100%" }}
                bodyStyle={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 16,
                }}
              >
                <img
                  src={Icons?.[service?.name]}
                  loading="lazy"
                  alt={service?.name}
                  style={{
                    width: 48,
                    height: 48,
                    objectFit: "contain",
                    marginBottom: 8,
                  }}
                />
                <Text strong style={{ fontSize: 12 }}>
                  {service?.name}
                </Text>
              </Card>
            </Col>
          ))}
      </Row>
    </Layout>
  );
};

export default Services;
